import { DeploymentRing } from '@fluidx/office-fluid-types';
import { safeLocalStorage } from '@fluidx/utilities';
import { OdspDriverManifestCacheEntry } from './OdspDriverManifestAccessors';
import { OdspDriverManifest } from './OdspDriverManifestType';

const OdspDriverManifestCacheStorageKeyPrefix = 'fluidOdspDriverManifestCache_';

//#region Odsp manifest related cache operations
export function getCachedManifestEntryForDeploymentRing(
  deploymentRing?: DeploymentRing
): OdspDriverManifestCacheEntry | null {
  // TODO: Task 5062111: Consider using indexdb instead of localStorage for ODSP manifest cache and prefetch entry
  const cacheEntry = safeLocalStorage()?.getItem(getManifestCacheKey(deploymentRing));
  if (!cacheEntry) {
    return null;
  }

  const parsed: OdspDriverManifestCacheEntry = JSON.parse(cacheEntry);
  return parsed;
}

export function cacheManifestEntryForDeploymentRing(
  manifest: OdspDriverManifest,
  deploymentRing?: DeploymentRing
): void {
  // TODO: Task 5062111: Consider using indexdb instead of localStorage for ODSP manifest cache
  const storage = safeLocalStorage();
  if (!storage) {
    return;
  }

  const manifestWithLastUpdatedTimestamp: OdspDriverManifestCacheEntry = { ...manifest, lastUpdatedTime: Date.now() };

  safeLocalStorage()?.setItem(getManifestCacheKey(deploymentRing), JSON.stringify(manifestWithLastUpdatedTimestamp));
}

/**
 * Checks whether ODSP driver caching is enabled
 **/
export function isManifestCachingMechanismEnabled(): boolean {
  // TODO: Task 5062111: Consider using indexdb instead of localStorage for ODSP manifest cache
  return !!safeLocalStorage();
}

function getManifestCacheKey(deploymentRing?: DeploymentRing): string {
  const deploymentRingOrDefault: Exclude<typeof deploymentRing, undefined> = deploymentRing || 'Prod';
  return OdspDriverManifestCacheStorageKeyPrefix + deploymentRingOrDefault;
}
//#endregion Odsp manifest related cache operations

//#region Prefetch-related cache operations
export function getCachedPrefetchEntryForDeploymentRing(deploymentRing?: DeploymentRing): string | null {
  // TODO: Task 5062111: Consider using indexdb instead of localStorage for ODSP manifest cache and prefetch entry
  const cacheEntry = safeLocalStorage()?.getItem(getPrefetchCacheKey(deploymentRing));
  return cacheEntry || null;
}

export function cachePrefetchEntryForDeploymentRing(entryName: string, deploymentRing?: DeploymentRing): void {
  // TODO: Task 5062111: Consider using indexdb instead of localStorage for ODSP manifest cache and prefetch entry
  const storage = safeLocalStorage();
  if (!storage) {
    return;
  }
  safeLocalStorage()?.setItem(getPrefetchCacheKey(deploymentRing), entryName);
}

/**
 * Get prefetch key name which is used to compare the driver file name from latest manifest json and the filename we previously prefetched to decide whether or not a new prefetch is required.
 */
function getPrefetchCacheKey(deploymentRing?: DeploymentRing): string {
  return getManifestCacheKey(deploymentRing) + '_prefetch';
}
//#endregion Prefetch related cache operations
